import React from "react";
import { Spin } from "antd";

const Loading = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <Spin
        size="large"
        style={{ position: "absolute", top: "50%", left: "50%" }}
      />
    </div>
  );
};

export default Loading;
